// Sidebar compartido para todas las vistas del panel de usuario
import React from "react";
import styles from "./PanelLayout.module.css";
import { Link, useNavigate, useLocation } from "react-router-dom";

function getInitials(name = "", lastName = "") {
  return `${name[0] || ""}${lastName[0] || ""}`.toUpperCase() || "?";
}

export const MENU_ITEMS = [
  { label: "Resumen", path: "/mis-consultas" },
  { label: "Mis citas", path: "/mis-citas" },
  { label: "Historial médico", path: "/historial-medico" },
  { label: "Mis recetas", path: "/mis-recetas" },
  { label: "Dependientes", path: "/dependientes" },
  { label: "Mi perfil", path: "/mi-perfil" },
];

export const MOCK_USER = {
  name: "Carlos",
  lastName: "García",
  email: "carlos.garcia@gmail.com",
  image: null,
  profileComplete: 70,
  lastConsult: { doctor: "Dr. Rojas", date: "28 Feb 2026" },
};

export function getInitialsFrom(user) {
  return getInitials(user?.name || "", user?.lastName || "");
}

export function PanelSidebar({ user }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const initials = getInitialsFrom(user);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  return (
    <aside className={styles.sidebar}>
      <div>
        <div className={styles.sidebarTop}>
          {user?.image ? (
            <img src={user.image} alt="avatar" className={styles.avatarImg} />
          ) : (
            <div className={styles.avatar}>{initials}</div>
          )}
          <p className={styles.userName}>
            {user?.name} {user?.lastName}
          </p>
          <p className={styles.userEmail}>{user?.email}</p>
          {user?.lastConsult && (
            <span className={styles.lastConsult}>
              Última: {user.lastConsult.doctor} · {user.lastConsult.date}
            </span>
          )}
        </div>

        <p className={styles.menuLabel}>Menú principal</p>
        <ul className={styles.menuList}>
          {MENU_ITEMS.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                className={`${styles.menuItem} ${pathname === item.path ? styles.menuItemActive : ""}`}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className={styles.sidebarBottom}>
        <button className={styles.btnLogout} onClick={handleLogout}>
          Cerrar sesión
        </button>
      </div>
    </aside>
  );
}

export function BellIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  );
}

export function PanelHeader({ label, title, user }) {
  const initials = getInitialsFrom(user);
  return (
    <div className={styles.mainHeader}>
      <div className={styles.mainHeaderLeft}>
        <p>{label}</p>
        <h1>{title}</h1>
      </div>
      <div className={styles.mainHeaderRight}>
        <button className={styles.bellBtn}>
          <BellIcon />
        </button>
        <div className={styles.headerAvatar}>{initials}</div>
      </div>
    </div>
  );
}

export function formatDate(dateStr) {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  return d.toLocaleDateString("es-PE", { day: "2-digit", month: "short", year: "numeric" });
}

export function getTipoBadge(tipo = "") {
  const t = tipo.toLowerCase();
  if (t.includes("online") || t.includes("tele") || t.includes("virtual"))
    return <span className={styles.badgeTele}>Teleconsulta</span>;
  if (t.includes("domicilio")) return <span className={styles.badgeDomicilio}>A domicilio</span>;
  return <span className={styles.badgePresencial}>Presencial</span>;
}

export function getEstadoBadge(status = "") {
  const s = status.toLowerCase();
  if (s === "completado" || s === "completed" || s === "completada")
    return <span className={styles.badgeCompletada}>Completada</span>;
  if (s === "cancelado" || s === "cancelada" || s === "cancelled")
    return <span className={styles.badgeCancelada}>Cancelada</span>;
  if (s === "confirmado" || s === "confirmada")
    return <span className={styles.badgeConfirmada}>Confirmada</span>;
  return <span className={styles.badgePendiente}>Pendiente</span>;
}

export function useUserData(axiosInstance) {
  const [user, setUser] = React.useState(null);

  React.useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setUser(MOCK_USER);
      return;
    }
    axiosInstance
      .get("/api/datapersonal")
      .then((r) => setUser(r.data))
      .catch(() => setUser(MOCK_USER));
  }, [axiosInstance]);

  return user;
}
